import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CCol,
  CRow,
} from '@coreui/react-pro'
import { FaCheck } from 'react-icons/fa'
import React from 'react'

const curricullum = [
  {
    title: 'PRE - SEASON',
    body: 'Cover basic software engineering principles: variables, functions, loop statements, if statements, basic algorithms and data structures. Begin using an IDE and the terminal. This track is the equivalent of a coding bootcamp.',
    languages: 'Languages: Javascript HTML/CSS',
  },
  {
    title: 'SEASON ONE ARC 1',
    body: 'Cover fundamental computer programming concepts and learn the basics of C. Build a solid foundation in back-end programming including pointers, arrays, strings, algorithms, data structures, data types, and software architecture.',
    languages: 'Languages: C',
  },
  {
    title: 'SEASON TWO - FULL STACK',
    body: 'Learners focus on back-end and front-end tools, languages and databases; they build 3 websites, rebuild a database; build a video game and multiple full stack applications from scratch, helping to develop their technical portfolio.',
    languages:
      'Track tech stack: Ruby, Ruby on Rails, Node.js, Javascript, HTML, CSS, Nginx, PostgreSQL, SQLite PhP, jQuery, REST APIs',
  },
  {
    title: 'SEASON THREE - FULL STACK',
    body: 'Specialize in one of 4 areas: front-end development, back-end databases, cloud deployment, or Java for some of our employer partners.',
    languages: 'Track tech stack: Ruby, React.JS, Java, AWS/GCP/Azure',
  },
  {
    title: 'SEASON TIPP',
    body: 'Learners join our Technical Interview Preparation Program. Learners do 20-40 technical interviews, submit their resume for review, and submit their LinkedIn profile for review. Interview worksheets and job application trackers are also part of the curriculum.',
    languages: 'Ruby, Python, Java, Javascript',
  },
]

const FullStackInfo = () => {
  return (
    <div className="px-2 px-lg-4">
      <div className="course-benefit p-4 my-3">
        <h3 className="mb-3">Jobs</h3>
        <CRow>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Front-end and back-end programming, Ruby on Rails, Javascript, advanced SQL
                  database knowledge, RESTful APIs, software architecture
                </p>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Experience building and developing software, familiarity with the software
                  development cycle, turn tech specs into an architecture and code base
                </p>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Problem solving, creativity, strong written and verbal communication, get-it-done
                  attitude
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </div>
      <div className="course-benefit p-4 my-3">
        <h3 className="mb-3">Outsource Global Academy</h3>
        <CRow>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Front-end and back-end programming, Ruby on Rails, Javascript, advanced SQL
                  database knowledge, RESTful APIs, software architecture
                </p>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Rebuild a database and build a customized website, an enterprise level app, a
                  mid-level game, an ecommerce store, and a from-scratch back-end
                </p>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={6}>
            <CRow>
              <CCol md={1}>
                <FaCheck size={12} />
              </CCol>
              <CCol md={11}>
                <p>
                  Structured problem solving, creativity, strong written and verbal communication
                  and collaboration skills, get-it-done attitude.
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
      </div>
      <div className="mt-5 pt-1">
        <h2 className="my-4">Fullstack Program Curriculum</h2>
        <CAccordion activeItemKey={1}>
          {curricullum.map(({ title, body, languages }, index) => (
            <CAccordionItem itemKey={index + 1} key={index}>
              <CAccordionHeader>{title}</CAccordionHeader>
              <CAccordionBody>
                {body}
                <br />
                <strong>{languages}</strong>
              </CAccordionBody>
            </CAccordionItem>
          ))}
        </CAccordion>
      </div>
    </div>
  )
}

export default FullStackInfo
